import { authFirstName } from './AuthStore';

export const updateAuthFirstName = (value) => authFirstName.update((oldValue) => value);
